module.exports = __webpack_public_path__ + "media/application/images/download_link-f7eef4f47dea859b3faad6e0651a6bd5.png";